// extracted by mini-css-extract-plugin
export default {"wrap":"GoogleSignInButton_wrap__KZGAc","button":"GoogleSignInButton_button__c5yPB","error":"GoogleSignInButton_error__b2xXQ"};